import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form,
  ToggleButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import { API_URL } from "../../../utilities/url";
import storage from "../../../services/storage";
import CryptoJS from "crypto-js";
import moment from "moment";

const ModalAddRep = ({
  show,
  filter,
  setFilter,
  selectedContacts,
  setSelectedContacts,
  selectedGroups,
  setSelectedGroups,
  handleClose,
  onSelectedDataChange,
}) => {
  const ITEMS_PER_PAGE = 7;
  const [searchQuery, setSearchQuery] = useState("");
  const [allData, setAllData] = useState([]); // Menyimpan data group
  const [tempSelectedData, setTempSelectedData] = useState([]); // Data sementara
  const [currentPage, setCurrentPage] = useState(1);
  const [selectAll, setSelectAll] = useState(false);

  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);

  useEffect(() => {
    if (!show) return;

    // console.log(selectedContacts);
    // console.log(selectedGroups);

    const endpoint =
      filter === "contact" ? "contact-broadcast" : "contact-group-list";

    setTempSelectedData(
      filter === "contact" ? selectedContacts : selectedGroups
    );

    axios
      .post(
        API_URL + endpoint,
        { idt_workspace: workspace.idt_user_workspace },
        { headers: { Authorization: `Bearer ${storage.get("access_token")}` } }
      )
      .then(({ data }) =>
        data.success ? setAllData(data.data || []) : setAllData([])
      )
      .catch((error) => console.error("Error fetching data:", error));
  }, [filter, show]);

  useEffect(() => {
    // Saat filter berubah, gunakan data yang sudah tersimpan
    setTempSelectedData(
      filter === "contact" ? selectedContacts : selectedGroups
    );
  }, [filter, selectedContacts, selectedGroups]);

  const filteredData = allData.filter((item) => {
    if (filter === "contact") {
      return [item.name_first, item.name_last, item.msisdn].some((field) =>
        field?.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );
    } else if (filter === "group") {
      return item.name?.toLowerCase().includes(searchQuery.toLowerCase());
    }
    return false;
  });
  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSelect = (item) => {
    const key = filter === "contact" ? item.msisdn : item.name;

    setTempSelectedData((prev) => {
      const exists = prev.some(
        (selected) =>
          (filter === "contact" ? selected.msisdn : selected.name) === key
      );

      const newSelectedData = exists
        ? prev.filter(
            (selected) =>
              (filter === "contact" ? selected.msisdn : selected.name) !== key
          )
        : [...prev, item];

      if (filter === "contact") {
        setSelectedContacts(newSelectedData);
      } else {
        setSelectedGroups(newSelectedData);
      }

      return newSelectedData;
    });
  };

  const handleSelectAll = () => {
    const isSelectingAll = !selectAll;

    setTempSelectedData((prev) => {
      let newSelectedData = [];

      if (isSelectingAll) {
        // Pilih semua data dari seluruh pagination, bukan hanya halaman saat ini
        newSelectedData = [
          ...prev,
          ...allData.filter(
            (item) =>
              !prev.some(
                (selected) =>
                  (filter === "contact" ? selected.msisdn : selected.name) ===
                  (filter === "contact" ? item.msisdn : item.name)
              )
          ),
        ];
      } else {
        // Uncheck semua data
        newSelectedData = [];
      }

      // Simpan ke state global (selectedContacts / selectedGroups)
      if (filter === "contact") {
        setSelectedContacts(newSelectedData);
      } else {
        setSelectedGroups(newSelectedData);
      }

      return newSelectedData;
    });

    setSelectAll(isSelectingAll);
  };

  useEffect(() => {
    setSelectAll(
      paginatedData.length > 0 &&
        paginatedData.every((item) =>
          tempSelectedData.some(
            (selected) =>
              (filter === "contact" ? selected.msisdn : selected.name) ===
              (filter === "contact" ? item.msisdn : item.name)
          )
        )
    );
  }, [filter, tempSelectedData, paginatedData]);

  const handleSubmit = () => {
    if (filter === "contact") {
      setSelectedContacts(tempSelectedData);
    } else {
      setSelectedGroups(tempSelectedData);
    }
    onSelectedDataChange([
      { type: "contact", data: selectedContacts },
      { type: "group", data: selectedGroups },
    ]);
    handleClose();
  };

  useEffect(() => {
    if (!show) {
      // setSelectedContacts([]);
      // setSelectedGroups([]);
      setTempSelectedData([]); // Reset saat modal ditutup
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Target Recipient</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* FILTER */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex gap-2">
            <ToggleButtonGroup
              type="radio"
              name="filter"
              value={filter}
              onChange={setFilter}
            >
              <ToggleButton
                id="contact"
                value="contact"
                variant="outline-info"
                style={{ boxShadow: "none" }}
              >
                By Contact
              </ToggleButton>
              <ToggleButton
                id="group"
                value="group"
                variant="outline-info"
                style={{ boxShadow: "none" }}
              >
                By Group
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          <Form.Control
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearch}
            className="form-control"
            style={{ width: "200px" }}
          />
        </div>

        {filter === "contact" ? (
          <table className="table table-striped table-bordered table-custome w-100">
            <thead>
              <tr className="text-white">
                <th className="p-2">
                  <Form.Check
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </th>
                <th className="p-2">First Name</th>
                <th className="p-2">Last Name</th>
                <th className="p-2">Title</th>
                <th className="p-2">Date of Birth</th>
                <th className="p-2">MSISDN</th>
                <th className="p-2">Email</th>
                <th className="p-2">Address</th>
                <th className="p-2">Group</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => handleSelect(item)}
                  style={{ cursor: "pointer" }}
                >
                  <td className="p-2">
                    <Form.Check
                      type="checkbox"
                      checked={tempSelectedData.some(
                        (selected) =>
                          (filter === "contact"
                            ? selected.msisdn
                            : selected.name) ===
                          (filter === "contact" ? item.msisdn : item.name)
                      )}
                      onChange={() => handleSelect(item)}
                    />
                  </td>
                  <td className="p-2">{item.name_first}</td>
                  <td className="p-2">{item.name_last}</td>
                  <td className="p-2">{item.title}</td>
                  <td className="p-2">
                    {item.date_of_birth
                      ? moment(item.date_of_birth).format("DD-MM-YYYY")
                      : null}
                  </td>
                  <td className="p-2">{item.msisdn}</td>
                  <td className="p-2">{item.email}</td>
                  <td className="p-2">{item.address}</td>
                  <td className="p-2">{item.contact_group}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <table className="table table-striped table-bordered table-custome w-100">
            <thead>
              <tr className="text-white">
                <th className="p-2">
                  <Form.Check
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </th>
                <th className="p-2">Group Name</th>
                <th className="p-2">Description</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => handleSelect(item)}
                  style={{ cursor: "pointer" }}
                >
                  <td className="p-2">
                    <Form.Check
                      type="checkbox"
                      checked={tempSelectedData.some(
                        (selected) =>
                          (filter === "contact"
                            ? selected.msisdn
                            : selected.name) ===
                          (filter === "contact" ? item.msisdn : item.name)
                      )}
                      onChange={() => handleSelect(item)}
                    />
                  </td>
                  <td className="p-2">{item.name}</td>
                  <td className="p-2">{item.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {/* Pagination */}
        <div className="d-flex justify-content-between">
          <div>
            Page {currentPage} of {totalPages}
          </div>
          {totalPages > 1 && (
            <div>
              <Button
                variant="primary"
                className="btn btn-sm me-2"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Prev
              </Button>
              <Button
                variant="primary"
                className="btn btn-sm"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </Button>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          Close
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAddRep;
